import SubscriberList from "./list";

const subscriberComponents = {
  list: SubscriberList,
};

export default subscriberComponents;
